const features = {
  medicare: {
    enabled: true,
  },
  externalPaymentProviders: {
    enabled: true,
  },
  googlePay: {
    enabled: true,
  },
};
export default features;
